import { alpha, createTheme, PaletteColorOptions } from '@mui/material/styles';
import { BREAKPOINTS, EXTRA_COLORS, THEME_CONFIG } from '@/config';
import { customShadows } from '@/config/custom-shadows';
import { overrides } from '@/config/overrides/overrides';

function tailwindColorToMui(
  color: {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    950: string;
  },
  contrastText = '#ffffff',
): PaletteColorOptions {
  return {
    ...color,
    A100: color[100],
    A200: color[200],
    light: color[200],
    A400: color[400],
    main: color[500],
    A700: color[700],
    dark: color[700],
    contrastText,
  };
}

const muiTheme = createTheme({
  typography: THEME_CONFIG.typography,
  shadows: THEME_CONFIG.shadows,
  customShadows: customShadows(),
  shape: {
    borderRadius: 4,
  },
  // Déclarés explicitement : sans cela le thème dépend des valeurs par défaut
  // de MUI, qui coïncident avec Tailwind par chance et non par contrat.
  breakpoints: {
    values: {
      xs: 0,
      sm: BREAKPOINTS.sm,
      md: BREAKPOINTS.md,
      lg: BREAKPOINTS.lg,
      xl: BREAKPOINTS.xl,
    },
  },
  palette: {
    background: {
      default: THEME_CONFIG.colors.background,
    },
    primary: tailwindColorToMui(THEME_CONFIG.colors.primary),
    secondary: tailwindColorToMui(THEME_CONFIG.colors.secondary),
    grey: THEME_CONFIG.colors.grey,
    error: tailwindColorToMui(THEME_CONFIG.colors.error),
    warning: tailwindColorToMui(THEME_CONFIG.colors.warning),
    success: tailwindColorToMui(THEME_CONFIG.colors.success),
    info: tailwindColorToMui(THEME_CONFIG.colors.info),
    action: {
      hover: alpha(THEME_CONFIG.colors.grey[100], 0.03),
      selected: alpha(THEME_CONFIG.colors.grey[100], 0.1),
      disabled: alpha(EXTRA_COLORS.neutral[100], 0.4),
      disabledBackground: alpha(EXTRA_COLORS.neutral[100], 0.1),
      focus: alpha(THEME_CONFIG.colors.grey[100], 0.06),
      active: THEME_CONFIG.colors.grey[400],
      hoverOpacity: 0.08,
      disabledOpacity: 0.2,
    },
    text: {
      primary: THEME_CONFIG.colors.grey[50],
      secondary: THEME_CONFIG.colors.grey[400],
      disabled: alpha(EXTRA_COLORS.neutral[50], 0.5),
    },
    mode: 'dark',
  },
  components: overrides,
});

export default muiTheme;
